import { createContext, useContext } from 'react'

export type BackendWakePhase = 'checking' | 'ready' | 'failed'

export type BackendWakeContextValue = {
  phase: BackendWakePhase
  showWakeBanner: boolean
}

const defaultValue: BackendWakeContextValue = {
  phase: 'ready',
  showWakeBanner: false,
}

export const BackendWakeContext = createContext<BackendWakeContextValue>(defaultValue)

export function useBackendWakeState(): BackendWakeContextValue {
  return useContext(BackendWakeContext)
}
